import { render, staticRenderFns } from "./menu-wrap.vue?vue&type=template&id=3aa0c6d2&scoped=true&"
import script from "./menu-wrap.vue?vue&type=script&lang=js&"
export * from "./menu-wrap.vue?vue&type=script&lang=js&"
import style0 from "./menu-wrap.vue?vue&type=style&index=0&id=3aa0c6d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa0c6d2",
  null
  
)

export default component.exports